<div class="main-container">
  <form [formGroup]="productionForm" novalidate>
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Production Device </span>
      </div>
      @if (ProductionDeviceCreate) {
        <div class="button-group">
          <button class="primary-button" (click)="AddNew()">
            Manual Upload <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
          <button class="primary-button" (click)="AddNewExcel()">
            Bulk Upload
            <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        </div>
      }
    </div>

    @if (ProductionDeviceView) {
      <div class="component-container">
        <!-- Component Header Section -->
        <div class="component-header">
          <h6 class="component-title">Production Device List</h6>
          <div class="component-actions">
            <app-common-search
              (searchSubmit)="onSearchInputChange($event)"
            ></app-common-search>
          </div>
        </div>

        <div class="component-separator"></div>
        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>UID</th>
                <th>IMEI</th>
                <th>ICCID</th>
                <th>Model Name</th>
                <th>Action</th>
              </tr>
            </thead>
            @if (productionDeviceList.length > 0) {
              <tbody>
                @for (item of productionDeviceList; track item) {
                  <tr>
                    <td>
                      {{ item.uid }}
                    </td>
                    <td>
                      {{ item.imei }}
                    </td>
                    <td>
                      {{ item.iccid }}
                    </td>
                    <td>
                      {{ item.modelName }}
                    </td>
                    <td>
                      <div class="action-buttons">
                        @if (ProductionDeviceUpdate) {
                          <button
                            class="primary-button view-button"
                            (click)="prepopulation(item.uid)"
                          >
                            <mat-icon class="btn-icon">visibility</mat-icon>
                          </button>
                        }
                        @if (ProductionDeviceDelete) {
                          <button
                            class="primary-button delete-button"
                            (click)="delete(item.uid)"
                          >
                            <mat-icon class="btn-icon">delete</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (productionDeviceList.length === 0) {
              <tbody>
                <tr>
                  <td colspan="7">
                    <img
                      loading="lazy"
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          @if (productionDeviceList.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalItems"
              [pageSize]="pageSize"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }
  </form>
</div>
